'use strict';
import template from './tags-edit.html';

DataTagsService.$inject = [
  '$modal',
];

export function DataTagsService($modal) {

  this.createOrUpdateDataTag = createOrUpdateDataTag;

  function createOrUpdateDataTag(tag) {
    return $modal.show({
      template: template,
      controller: 'DataTagsCreateController',
      locals: {
        dataTag: tag,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/services/DataTagsService.js